// 表格图
<template>
  <div style="padding-bottom: 20px" v-if="tableDataAll && tableDataAll.columns.length && tableDataAll.data.records.length">
    <div style="font-weight: 700; font-size: 16px; padding-bottom: 10px; text-align: left">
      {{ `题目` }}
    </div>
    <table
      border="1"
      cellspacing="0"
      style="
        width: 100%;
        table-layout: fixed;
        word-wrap: break-word;
        margin: 0 auto;
        text-align: center;
        border-collapse: collapse;
      "
    >
      <thead>
        <tr>
          <th v-for="(item, index) in tableDataAll.columns" :key="index">
            <span>{{ item }}</span>
          </th>
        </tr>
      </thead>
      <tbody>
        <tr v-for="(recordItem, j) in tableDataAll.data.records" :key="j">
          <td v-for="(columnItem, i) in tableDataAll.columns" :key="i">
            <span>
              {{ recordItem['column_' + i] || '-' }}
            </span>
          </td>
        </tr>
      </tbody>
    </table>
  </div>
</template>

<script>
export default {
  components: {},
  props: ['tableDataAll'],
  data() {
    return {};
  },
  created() {},
  mounted() {},
  methods: {
    formatTooltip(val) {
      return Number(val);
    },
    getProgressBar(item) {
      return `width:${
        250 * (item.rate / 100)
      }px;height: 10px;border-radius: 10px;background-color:#409eff;position:absolute;top:0`;
    },
  },
};
</script>

<style lang="less" scoped>
// 滑块样式
.slider-content {
  width: 80%;
  position: relative;
  .slider-content-tips {
    position: absolute;
    right: -55px;
    top: 0;
    transform: translateY(25%);
  }
}
.el-slider__runway.disabled .el-slider__bar {
  background-color: #409eff;
}
.el-slider__runway.disabled .el-slider__button {
  display: none;
}
.tdBg {
  border-bottom: none;
  border-right: none;
  padding: 0 6px;
}
</style>
